export const getCurrencyDecimals = (currencies) => currencies.map(c => ({ [c.code.toUpperCase()]: c.decimals }));
const getDecimalsByCurrencyCode = (currency, currencies) => {
    const fiatArr = [{ USD: 2 }, { EUR: 2 }];
    const obj = Object.assign({}, ...getCurrencyDecimals(currencies), ...fiatArr);
    return obj[currency.toUpperCase()];
};
export default getDecimalsByCurrencyCode;
